/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Badge_PtzInputs */

const vi_grower_area_camera_badge_ptz = /** @type {(inputs: Grower_Area_Camera_Badge_PtzInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PTZ`)
};

/**

* @param {Grower_Area_Camera_Badge_PtzInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_badge_ptz = /** @type {((inputs?: Grower_Area_Camera_Badge_PtzInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Badge_PtzInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_badge_ptz(inputs)
});